<template>
  <div class="collection-auth-component d-flex flex-column align-center">
    <loader v-if="isLoading" absolute />
    <template v-else-if="!showCodeVerification">
      <div class="full-height d-flex flex-column align-center justify-center">
        <h1 class="page-title font-weight-regular text-center">
          Требуется авторизация!
        </h1>
        <span class="page-sub-title label text-center">
          Выберите сотрудника и получите код
        </span>
        <v-select
          v-model="selectedEmployee"
          :items="employees"
          item-text="name"
          item-value="id"
          class="select"
          height="58px"
          outlined
          :disabled="isLoading"
          :loading="isLoading"
        />
        <v-btn
          class="button-primary"
          dark
          :disabled="!selectedEmployee"
          :loading="sendingAuthCode"
          @click="sendAuthCode"
        >
          Получить код
        </v-btn>
      </div>
    </template>

    <template v-else-if="showCodeVerification">
      <div class="full-height d-flex flex-column align-center justify-center">
        <h1 class="page-title font-weight-regular text-center">
          Введите код подтверждения
        </h1>
        <span class="page-sub-title label text-center">
          {{ authCodeValidationDescription }}
        </span>
        <div class="code-input-section">
          <code-input
            class-name="code-input"
            :fields="4"
            auto-focus
            @change="updateAuthCode"
            @complete="createCollectionType"
          />
        </div>
        <v-btn
          class="button-primary"
          :disabled="authCode.length < 4"
          :loading="sendingAuthCode"
          @click="createCollectionType"
        >
          Продолжить
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CodeInput from 'vue-verification-code-input'
  import mixinsSnackbarMessage from '@/mixins/snackbar-message'
  import AuthCodeProvider from '@/models/enums/AuthCodeProvider'

  export default {
    name: 'TransactionAuth',
    components: {
      CodeInput,
    },
    mixins: [mixinsSnackbarMessage],
    props: {
      type: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        sendingAuthCode: false,
        showCodeVerification: false,
        authCodeProvider: AuthCodeProvider.Sms,
        selectedEmployee: null,
        employees: [],
        isLoading: false,
        authCode: '',
        transactionId: null,
      }
    },
    computed: {
      ...mapGetters({
        localStorageBranch: 'branches/getLocalStorageBranch',
      }),
      authCodeValidationDescription () {
        return AuthCodeProvider.getValidationDescription(this.authCodeProvider)
      },
    },
    mounted () {
      this.loadTransactionUsers()
    },
    methods: {
      updateAuthCode (value) {
        this.authCode = value
      },
      createCollectionType () {
        if (this.authCode.length < 4) return

        this.sendingAuthCode = true
        const params = {
          filialId: this.localStorageBranch.id,
          // userId: 38,
          userId: this.selectedEmployee,
          type: this.type,
          authCode: this.authCode,
        }
        this.$store.dispatch('transactions/createCollectionType', params).then(res => {
          if (res.status === 200) {
            const receiver = this.employees.find(item => item.id === this.selectedEmployee)
            this.$emit('updateAuth', true)
            this.$emit('updateTransactionInfo', res.data.data)
            this.$emit('updateReceiver', receiver)
          } else {
            this.showErrorMessage(res.response.data.message)
          }
        })
          .finally(() => {
            this.sendingAuthCode = false
          })
      },
      async loadTransactionUsers () {
        const params = {
          filialId: this.localStorageBranch.id,
        }
        this.isLoading = true
        try {
          const res = await this.$store.dispatch('transactions/canAcceptCollectTransaction', params)
          this.employees = res.data.items || []
        } catch (err) {
          console.warn('Error', err)
        } finally {
          this.isLoading = false
        }
      },
      async sendAuthCode () {
        this.sendingAuthCode = true
        const data = {
          userId: this.selectedEmployee,
          filialId: this.localStorageBranch.id,
        }
        try {
          const res = await this.$store.dispatch('transactions/sendAuthCode', data)
          this.showCodeVerification = true
          this.authCodeProvider = res.provider || AuthCodeProvider.Sms
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.sendingAuthCode = false
      },
    },
  }
</script>

<style lang="less" scoped>
  .collection-auth-component {
    height: calc(100vh - 250px);
    position: relative;

    .full-height {
      height: 100%;
      width: 100%;
    }

    .select {
      width: 400px;
      border-radius: 10px;
      flex: 0;
      margin-bottom: 24px;
      .media-sm({
        max-width: 80%;
      });
    }

    .page-title {
      font-size: 60px;
      margin-bottom: 12px;
      .media-sm({
        font-size: 30px;
      });
    }

    .label {
      display: block;
      margin-bottom: 10px;
      font-size: 18px;
    }

    .page-sub-title {
      font-size: 16px;
      margin-bottom: 52px;
    }

    .button {
      max-width: 100%;
      width: 400px;
      height: 60px;
      font-size: 18px;
      border-radius: 10px;
      background-color: @color-primary !important;
    }

    .v-btn {
      max-width: 100%;
      width: 400px;
    }

    .text-field {
      max-width: 500px;
      width: 100%;
      margin-bottom: 16px;

      &.password-field {
        ::v-deep {
          .v-icon.v-icon.v-icon--link {
            color: @color-primary !important;
          }
        }
      }

      ::v-deep {
        .v-input__slot {
          height: 60px;
          border: 1px solid @color-primary !important;
        }
      }
    }

    .code-input-section {
      width: 400px;
      margin-bottom: 35px;
      .code-input {
        width: 100% !important;
        ::v-deep {
          .react-code-input {
            display: flex;
            justify-content: center;
          }
          input {
            margin-right: 20px;
            height: 60px !important;
            border-radius: 10px !important;
            background: #f1f3f6 !important;
            border: 1px solid #cecece !important;
            font-size: 50px;
            padding: 0;
            font-family: "Roboto", sans-serif;
          }
        }
      }
    }
  }
</style>
